
import React, { useEffect } from 'react';

const ScrollObserver: React.FC = () => {
  useEffect(() => {
    // Function to handle intersection observer
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        // Add/remove the "in-view" class based on visibility
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          
          // Remove the class after animation completes
          setTimeout(() => {
            if (document.body.contains(entry.target)) {
              entry.target.classList.remove('in-view');
            }
          }, 1500);
        }
      });
    };

    // Set up intersection observer
    const observer = new IntersectionObserver(handleIntersection, {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.3, // trigger when 30% of the element is visible
    });

    // Target all card elements
    const cardElements = document.querySelectorAll('.card-hover-effect');
    cardElements.forEach((card) => observer.observe(card));

    // Cleanup function
    return () => {
      cardElements.forEach((card) => observer.unobserve(card));
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ScrollObserver;
